import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'

import {COMMON_APPROVERS_WIDGET_NAMESPACE} from '../consts'

const commonApproversTranslationModule: TranslationModule = {
  namespace: COMMON_APPROVERS_WIDGET_NAMESPACE,
  resources: {
    'en-US': () => import('./en_US.json'),
    'en-GB': () => import('./en_GB.json'),
    'de-DE': () => import('./de_DE.json'),
    'ru-RU': () => import('./ru_RU.json'),
    'it-IT': () => import('./it_IT.json'),
    'fr-FR': () => import('./fr_FR.json'),
    'cs-CZ': () => import('./cs_CZ.json'),
    'hu-HU': () => import('./hu_HU.json'),
    'nl-NL': () => import('./nl_NL.json'),
    'sv-SE': () => import('./sv_SE.json'),
    'es-ES': () => import('./es_ES.json'),
    'ro-RO': () => import('./ro_RO.json'),
    'no-NO': () => import('./no_NO.json'),
    'pl-PL': () => import('./pl_PL.json')
  }
}

const externalPackageTranslations: TranslationModule[] = []

export const commonApproversWidgetTranslations = combineTranslationBundles([
  externalPackageTranslations,
  commonApproversTranslationModule
])
